<template>
  <NodeViewWrapper
    :id="id"
    class="image-placeholder uploading"
  >
    <div
      :style="wrapperStyle"
      class="mx-auto"
    ></div>
    <NodeViewContent />
  </NodeViewWrapper>
</template>

<script>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import constants from '@/utilities/constants';
import useIsBrowser from '@/utilities/composables/useIsBrowser.ts';

export default {
  name: 'StImagePlaceholder',
  components: {
    NodeViewWrapper,
    NodeViewContent,
  },

  props: nodeViewProps,

  setup() {
    const { isSafari } = useIsBrowser();
    return {
      isSafari,
    };
  },

  data() {
    return {
      height: 0,
      setHeightTimeout: null,
    };
  },

  computed: {
    base64() {
      return this.node.attrs.imgsrc;
    },

    width() {
      return this.node.attrs.width || constants.stImageDefaultWidth;
    },

    id() {
      return this.node.attrs.uploadId;
    },

    wrapperStyle() {
      return {
        height: `${this.height}px`,
        width: `${this.width}px`,
        background: 'linear-gradient(123.31deg, #DADCDF -0.03%, rgba(255, 255, 255, 0) 115.1%)',
        borderRadius: '8px',
      };
    },
  },
  mounted() {
    const setHeight = () => {
      this.height = this.node.attrs.height || constants.stImageDefaultHeight;
    };
    if (this.isSafari) {
      // delay setting height for safari after browser's scroll into view is done in input
      this.$nextTick(() => {
        this.setHeightTimeout = setTimeout(() => {
          setHeight();
        }, 200);
      });
    } else {
      setHeight();
    }
  },
  unmounted() {
    if (this.setHeightTimeout) {
      clearTimeout(this.setHeightTimeout);
    }
  },
};
</script>

<style lang="scss">
.image-placeholder {
  position: relative;
}
</style>
